export default "/images/2da86b683b05727b97aeef6603f6c7c3.png";